import { Box, Tab, Typography } from "@mui/material"
import { SyntheticEvent, useEffect, useMemo, useState } from "react"
import { ChannelSend, FrequencySend, Tabs } from "./utils/enums/tabs"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { TabContext, TabList, TabPanel } from "@mui/lab"
import dayjs, { Dayjs } from "dayjs"
import { BreadCrumb, SnackSimple } from "../../../../../../components"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import Loader from "../../../../../../components/loader"
import { Constants } from "../../../../../../utils/constants"
import { reportFolioServices } from "../../../../../../utils/constants/callService"
import { Types } from "../../../../../../utils/enums"
import { Notification } from "./components/notifications"
import { Users } from "./components/users"
import { useInput } from "./utils/hooks/useInput"
import { ChannelOption, channelSending, frequencySending } from "./utils/constans/constans"
import { useTables } from "./utils/hooks/useTables"
import { formatNotificationResponse } from "./utils/methods/formatEndpointResponseToInformation"
import { Body } from "./types"

export const NotificationCenter = () => {

    const { t } = useTranslation()
    const styles = useStyles()

    const [value, setValue] = useState(Tabs.NOTIFICATIONS)
    const handleChange = (_: SyntheticEvent | null, newValue: Tabs) => {
        setValue(newValue)
    }

    const initialChannelOptions = useMemo(() => channelSending(t), [t]);
    const initialFrequencyOptions = useMemo(() => frequencySending(t), [t]);

    const [channelOptions, setChannelOptions] = useState<ChannelOption[]>(initialChannelOptions);
    const [frequencyOptions, setFrequencyOptions] = useState<ChannelOption[]>(initialFrequencyOptions);
    const [valueDate, setValueDate] = useState<Dayjs | null>(dayjs());
    const [selectedDay, setSelectedDay] = useState<number | undefined>();
    const [id, setId] = useState<number | null>();
    const [loading, setLoading] = useState({ load: false, submit: false })

    const allChecksFalse = channelOptions.every(item => !item.check) || frequencyOptions.every(item => !item.check);
    const isConditionMet = frequencyOptions.some(item => item.id === String(FrequencySend.WEEKLY) && item.check) && !selectedDay;
    const disableButton = allChecksFalse || isConditionMet || !valueDate

    const handleChannelChecks = (channel: string) => {
        setChannelOptions((prevOptions) =>
            prevOptions.map((option) =>
                option.value === channel
                    ? { ...option, check: !option.check } // Cambia el estado de `check`
                    : option
            )
        );
    }

    const handleFrequencyChecks = (channel: string) => {
        setFrequencyOptions((prevOptions) =>
            prevOptions.map((option) =>
                option.value === channel
                    ? { ...option, check: !option.check } // Cambia el estado de `check`
                    : { ...option, check: false }
            )
        );
    }


    const { column, openDrawer, closeDrawer, selectedUsers, setSelectedUsers } = useTables()

    const { inputCreate, createFilter, modalLoad, handleSubmitUser, searchUsers, snackbar, closeSnackbar, loadings, loadUsers, cancelSearchUsers, setSnackbar, body, checks, setChecks } = useInput({ setSelectedUsers, closeDrawer })

    const getNotification = async () => {
        setLoading(prev => ({ ...prev, load: true }))
        const response = await reportFolioServices.getNotificationGeneral()

        const { notification } = formatNotificationResponse({ response })

        if (notification) {
            setId(notification.id)
            const [hours, minutes, seconds] = notification.time.split(":").map(Number);
            setValueDate(dayjs().hour(hours).minute(minutes).second(seconds).millisecond(0));
            setSelectedDay(notification.daysOfWeek[0])
            setFrequencyOptions((prevOptions) =>
                prevOptions.map((option) =>
                    option.value === String(notification.frequencyType)
                        ? { ...option, check: true }
                        : { ...option, check: false }
                )
            );
            setChannelOptions((prevOptions) =>
                prevOptions.map((option) =>
                    option.value === String(ChannelSend.EMAIL)
                        ? { ...option, check: notification.email } // Cambia el estado de `check`
                        : { ...option, check: notification.app }
                )
            );
        }

        setLoading(prev => ({ ...prev, load: false }))
    }

    const handleSubmit = async () => {
        setLoading(prev => ({ ...prev, submit: true }))
        const body: Body = {
            email: channelOptions.find(option => option.value === String(ChannelSend.EMAIL))?.check ?? false,
            app: channelOptions.find(option => option.value === String(ChannelSend.APP))?.check ?? false,
            frequencyType: Number(frequencyOptions.find(option => option.check === true)?.value),
            daysOfWeek: [selectedDay ?? 1],
            time: valueDate?.format(Constants.timeFormat) ?? '00:00:00'
        }
        if (id) {
            const response = await reportFolioServices.updateNotificationGeneral({ id, body })

            if (!response.error) {
                setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.update.success"), type: Types.SUCCESS }))
            } else {
                setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.update.error"), type: Types.ERROR }))
            }
        } else {
            const response = await reportFolioServices.createNotificationGeneral(body)

            if (!response.errors) {
                setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.create.success"), type: Types.SUCCESS }))
                setId(response.data.id)
            } else {
                setSnackbar(prev => ({ ...prev, open: true, message: t("reportFolio.notificationCenter.snackBar.create.error"), type: Types.ERROR }))
            }
        }
        setLoading(prev => ({ ...prev, submit: false }))
    }

    useEffect(() => {
        getNotification()
    }, [])



    return (
        <Box sx={styles.container}>
            <Box sx={styles.subContainer}>
                <BreadCrumb
                    removeBreadcrumb={['report-folio']}
                />

                <Typography variant="title_grey_big">{t('reportFolio.notificationCenter.notificationCenterByFolio')}</Typography>

                <Box sx={styles.tabsContainer}>
                    <TabContext value={value}>
                        <TabList sx={[styles.TabList]} onChange={handleChange} centered>
                            <Tab label={t('reportFolio.notificationCenter.tabs.notification').toUpperCase()} value={Tabs.NOTIFICATIONS} />

                            <Tab label={t('reportFolio.notificationCenter.tabs.users').toUpperCase()} value={Tabs.USERS} />
                        </TabList>

                        <TabPanel value={Tabs.NOTIFICATIONS} sx={styles.TabPanel}>
                            {loading.load ? (
                                <Loader />
                            ) : (
                                <Notification
                                    channelOptions={channelOptions}
                                    disableButton={disableButton}
                                    frequencyOptions={frequencyOptions}
                                    handleChannelChecks={handleChannelChecks}
                                    handleFrequencyChecks={handleFrequencyChecks}
                                    selectedDay={selectedDay}
                                    setSelectedDay={setSelectedDay}
                                    setValueDate={setValueDate}
                                    valueDate={valueDate}
                                    handleSubmit={handleSubmit}
                                    loadingButton={loading.submit}
                                />
                            )}
                        </TabPanel>

                        <TabPanel value={Tabs.USERS} sx={styles.TabPanel}>
                            <Users
                                checks={checks}
                                setChecks={setChecks}
                                rigthItem={<DinamicForm input={Object.values(inputCreate ?? {})} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />}
                                cleanFilter={() => {
                                    setChecks(() => ({ [ChannelSend.EMAIL]: false, [ChannelSend.APP]: false }))
                                    createFilter.cleanFilter()
                                }}
                                disabledButton={!body.users.length}
                                column={column}
                                row={modalLoad?.tmpUsuers as Record<string, string>[]}
                                openDrawer={openDrawer}
                                closeDrawer={closeDrawer}
                                selectedUsers={selectedUsers}
                                setSelectedUsers={setSelectedUsers}
                                loading={loadings.submit}
                                searchButton={{
                                    loading: !!loadings.search,
                                    disabled: !createFilter.query?.filter,
                                    onClick: searchUsers
                                }}
                                loadData={{
                                    loading: !!loadings.load,
                                    onClick: loadUsers
                                }}
                                close={cancelSearchUsers}
                                handleSubmitUser={handleSubmitUser}
                            />
                        </TabPanel>
                    </TabContext>
                </Box>
            </Box>

            <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
        </Box>
    )
}
